import { UserAddress } from './user-address.model';
import { Proof } from './Proof';

export class User {
    readonly _id: string;
    email: string;
    pan: {
        pan_no: string;
        proofs: Proof[];
        readonly verificationStatus?: VerificationStatus;
    };
    gender: string;
    marital_status: string;
    readonly name: string;
    readonly mobile_no: string;
    readonly onboardedBy: string;
    readonly generated_user_id: string;
    correspondence_address: UserAddress;
    addresses: string[];
    dob: string;
    educational_qualification: string;
    identity: {
        proofs: Proof[],
        readonly verificationStatus?: VerificationStatus;
    };
    aadhaarLinkedWithMobile: boolean;
    updatedAt: Date;
    createdAt?: Date;

    loan_details: UserLoanDetails[];

    constructor(id?: string) {
        this._id = id;
    }
}

export interface UserLoanDetails {
    loan_id: string;
    _id: string
}
export interface CreateUserResponse {
    userId: string;
    authToken: string;
    name: string;
}

export enum VerificationStatus {
    PENDING = 'pending',
    VERIFIED = 'verified',
    REJECTED = 'rejected'
}
